import {
  CheckNotes,
  InspectionCase,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';
import {
  ShutdownPumpDetailsCheck,
  ShutdownPumpDetailsCheckDto
} from './shutdown-pump-details-check.dto';

export class WaterSupplySourceDto extends InspectionCase {
  measuringStationAccordingSpec?: InspectionCase;
  waterStatsBeforeStationAccordingSpec?: InspectionCase;
  waterStatsBeforeSprayerHeadAccordingSpec?: InspectionCase;
  shutdownPumpType?: InspectionCase;
  shutdownPumpDetails?: ShutdownPumpDetailsCheckDto;
  reservoirVolume?: InspectionWaterSupplyDataCaseDto;
  backedupByMunicipalWaterNetwork?: InspectionCase;
  fireExtinguishersWaterSupplySource?: InspectionCase;
}

export class WaterSupplySource extends WaterSupplySourceDto {
  constructor(data: WaterSupplySourceDto = { title: 'מקור אספקת מים' }) {
    super(data);
    this.measuringStationAccordingSpec = new InspectionCase({
      ...data.measuringStationAccordingSpec,
      title: 'תחנת המדידה הותקנה בהתאם לדרישות התכנון והתקן?'
    });
    this.waterStatsBeforeStationAccordingSpec = new InspectionCase({
      ...data.waterStatsBeforeStationAccordingSpec,
      title:
        'האם נתוני מדידת המים לפני תחנת המדידה (גמל המים) מתאים לדרישות התכנון והתקן'
    });
    this.waterStatsBeforeSprayerHeadAccordingSpec = new InspectionCase({
      ...data.waterStatsBeforeSprayerHeadAccordingSpec,
      title:
        'האם נתוני מדידת המים לפני ראש מערכת המתזים מתאים לדרישות התכנון והתקן'
    });
    this.shutdownPumpType = new InspectionCase({
      ...data.shutdownPumpType,
      title: 'ציין את סוג משאבת הכיבוי הקיימים באתר (חשמלית, דיזל או אחר)'
    });
    this.shutdownPumpDetails = new ShutdownPumpDetailsCheck(
      data.shutdownPumpDetails
    );
    this.reservoirVolume = new InspectionWaterSupplyDataCase({
      ...data.reservoirVolume,
      title: 'ציין את נפח מאגר המים'
    });
    this.backedupByMunicipalWaterNetwork = new InspectionCase({
      ...data.backedupByMunicipalWaterNetwork,
      title: 'האם קיים גיבוי מרשת מים עירונית'
    });
    this.fireExtinguishersWaterSupplySource = new InspectionCase({
      ...data.fireExtinguishersWaterSupplySource,
      title:
        'האם אספקת המים לעמדות כיבוי אש פנימיות מרשת מים עירונית או משאבת כיבוי'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.measuringStationAccordingSpec.isApplicable ||
        this.measuringStationAccordingSpec.isPassed) &&
        (!this.waterStatsBeforeStationAccordingSpec.isApplicable ||
          this.waterStatsBeforeStationAccordingSpec.isPassed) &&
        (!this.waterStatsBeforeSprayerHeadAccordingSpec.isApplicable ||
          this.waterStatsBeforeSprayerHeadAccordingSpec.isPassed) &&
        (!this.shutdownPumpType.isApplicable ||
          this.shutdownPumpType.isPassed) &&
        (!this.shutdownPumpDetails.isApplicable ||
          this.shutdownPumpDetails.isPassed) &&
        (!this.reservoirVolume.isApplicable || this.reservoirVolume.isPassed) &&
        (!this.backedupByMunicipalWaterNetwork.isApplicable ||
          this.backedupByMunicipalWaterNetwork.isPassed) &&
        (!this.fireExtinguishersWaterSupplySource.isApplicable ||
          this.fireExtinguishersWaterSupplySource.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.measuringStationAccordingSpec.getNotes(),
      ...this.waterStatsBeforeStationAccordingSpec.getNotes(),
      ...this.waterStatsBeforeSprayerHeadAccordingSpec.getNotes(),
      ...this.shutdownPumpType.getNotes(),
      ...this.shutdownPumpDetails.getNotes(),
      ...this.reservoirVolume.getNotes(),
      ...this.backedupByMunicipalWaterNetwork.getNotes(),
      ...this.fireExtinguishersWaterSupplySource.getNotes()
    ];
  }
}
